import { Breadcrumb, Button, Container } from "components";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

import { useContext, useRef } from "react";

import "./Service.scss";

import { ServiceSlider } from "./ServiceSlider";
import { useWindowSize } from "rooks";
import { ServiceSliderCard } from "./ServiceSlider/ServiceSliderCard";
import { useService } from "./hooks";
import { useNavigate, useParams } from "react-router-dom";
import { convertRawToHtml, generateImageLink } from "utils";
import { AuthContext } from "providers/AuthProvider/context/AuthContext";
import { useIntl } from "react-intl";
import { languages_enum } from "redux/actions/globalSlice";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export function Service() {
  const { authorizationStage } = useContext(AuthContext);
  const navigate = useNavigate();

  const nextRef = useRef<HTMLButtonElement>(null);
  const prevRef = useRef<HTMLButtonElement>(null);
  const { id } = useParams();

  const { innerWidth } = useWindowSize();
  const { service } = useService(id as string);
  const { formatMessage } = useIntl();
  const language = useSelector((state: RootState) => state.global.language);
  const prefix = language === languages_enum.GEORGIAN ? "" : `/${language}`;

  return (
    <div className="service">
      <Container>
        <Breadcrumb
          className="service__breadcrumb"
          links={[
            {
              label: formatMessage({
                id: "main.breadcrumb",
                defaultMessage: "Home",
              }),
              value: `${prefix}/`,
            },
            {
              label: formatMessage({
                id: "services.breadcrumb",
                defaultMessage: "Services",
              }),
              value: `${prefix}/services`,
            },
            {
              label: service?.title || "",
              value: `${prefix}/services` + service?.id,
            },
          ]}
        />
      </Container>

      <div className="service__hero">
        <div className="service__hero-info">
          <h1 className="service__hero-info-title">{service?.title}</h1>
          <Button
            className="service__hero-info-button"
            onClick={() =>
              authorizationStage !== "authorized"
                ? navigate("/login")
                : navigate("/pr-visit-doctor/reserve/for")
            }
          >
            {formatMessage({
              id: "service.reserve-doctor",
              defaultMessage: "Reserve a Doctor",
            })}
          </Button>
        </div>
        <img
          className="service__hero-image"
          src={generateImageLink({
            imageId: service?.cover_image,
          })}
          alt="service-hero"
          loading="lazy"
        />
      </div>

      <div className="service__info">
        {convertRawToHtml(service?.content)}
      </div>

      <div className="service__address-slider">
        <div className="service__address-slider-header">
          <h6 className="service__address-slider-header-title">
            {formatMessage({
              id: "service.available-branches",
              defaultMessage: "Service is available at:",
            })}
          </h6>

          {innerWidth && innerWidth >= 1100 && (
            <div className="service__address-slider-header-buttons">
              <Button.RoundedButton ref={prevRef}>
                <MdOutlineKeyboardArrowLeft />
              </Button.RoundedButton>
              <Button.RoundedButton ref={nextRef}>
                <MdOutlineKeyboardArrowRight />
              </Button.RoundedButton>
            </div>
          )}
        </div>

        {innerWidth && innerWidth <= 1100 ? (
          <>
            {service?.branches?.map((branch: any) => (
              <ServiceSliderCard
                key={branch?.id}
                workingTime={branch?.working_time}
                address={branch?.address}
                title={branch?.title}
                email={branch?.email}
                location={branch?.region}
              />
            ))}
          </>
        ) : (
          <ServiceSlider
            branches={service?.branches}
            prevRef={prevRef}
            nextRef={nextRef}
          />
        )}
      </div>
    </div>
  );
}
